import { JSX, useState } from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

interface Props {
  value: string;
  onChange: (v: string) => void;
}

export default function AccountNumberInput({
  value,
  onChange,
}: Props): JSX.Element {
  const [visible, setVisible] = useState(false);

  return (
    <TextField
      fullWidth
      type={visible ? 'text' : 'password'}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      inputProps={{ 'data-testid': 'account-number-input' }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setVisible((v) => !v)}
              aria-label={
                visible ? 'Hide account number' : 'Show account number'
              }
              data-testid="account-number-toggle"
            >
              {visible ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
    />
  );
}
